<ng-template #titleTpl>
  <!-- El estado va en el subtítulo, en su propio renglón, y no como badge a la
       derecha del título: la pastilla compite con la "X" y encajona lo que un
       punto de color ya dice. La fecha de envío no se repite — es el primer paso
       del seguimiento. -->
  <!-- El `<intelishs-status-text>` es hijo ESTÁTICO del `page-header`, y tiene
       que serlo: la proyección se resuelve contra los hijos estáticos al crear
       el componente, así que un elemento envuelto en `@if` vive en una vista
       embebida, no casa con `select="[slot=subtitulo]"` y —al no haber
       `<ng-content>` catch-all— se descarta EN SILENCIO. Por eso la condición
       duplica el encabezado en vez de envolver lo proyectado. -->
  @if (solicitud()) {
    <intelishs-page-header title="Detalle de solicitud">
      <intelishs-status-text slot="subtitulo" [tone]="tono()">
        {{ estadoTexto() }}
      </intelishs-status-text>
    </intelishs-page-header>
  } @else {
    <intelishs-page-header title="Detalle de solicitud" />
  }
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="null"
  nzWidth="480px"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (solicitud(); as sol) {
      <div class="resolucion-modal">
        <!-- Sin section-header: esta sección abre el modal y su línea quedaba a
             unos pixeles de la del encabezado, leyéndose como una raya doble.
             "Seguimiento" sí lo lleva —ahí sí separa bloques—. -->
        <div class="detalle-seccion">
          <div class="seccion-panel">
            <div class="detalle-grid" style="grid-template-columns: 1fr 1fr 1fr">
              <app-detail-field label="Días hábiles" layout="stacked">{{
                sol.diasSolicitados
              }}</app-detail-field>
              <app-detail-field label="Fecha inicio" layout="stacked">{{
                sol.fechaInicio | date: 'dd/MM/yyyy'
              }}</app-detail-field>
              <app-detail-field label="Fecha fin" layout="stacked">{{
                sol.fechaFin | date: 'dd/MM/yyyy'
              }}</app-detail-field>
            </div>

            @if (sol.comentarios) {
              <app-detail-field label="Tu comentario" layout="stacked" [full]="true">
                {{ sol.comentarios }}
              </app-detail-field>
            }
          </div>
        </div>

        <!-- Sin `nz-divider` entre secciones: el section-header ya trae su
             propia línea, y las dos juntas parten el modal en franjas. -->

        <!-- Seguimiento: vista del empleado. SÍ muestra el comentario de quien
             resolvió, NO su nombre.

             El comentario tiene que estar: es el único lugar donde el empleado
             puede enterarse de por qué le rechazaron la solicitud, o de un
             ajuste al aprobarla ("se consideran 3 días del 1 al 3"). Ocultarlo
             además contradecía lo que el propio sistema le promete a quien
             resuelve: la sección donde el director escribe se titula
             "Comentario para el empleado" y su placeholder decía "Visible para
             el empleado…". Se escribía un motivo que no llegaba a nadie.

             El nombre sí se queda fuera: al empleado le importa la razón, no
             quién firmó; su director ya lo conoce y el de RH no le aporta. -->
        <div class="detalle-seccion">
          <intelishs-section-header title="Seguimiento" />
          <ol class="tl">
            @for (paso of pasos(); track paso.titulo) {
              <li class="tl-item" [class]="'tl-item--' + paso.estado">
                <span class="tl-dot"></span>
                <div class="tl-body">
                  <div class="tl-head">
                    <span class="tl-titulo">{{ paso.titulo }}</span>
                    @if (paso.fecha) {
                      <span class="tl-fecha">{{ paso.fecha | date: 'dd/MM/yyyy' }}</span>
                    }
                  </div>
                  @if (paso.detalle) {
                    <p class="tl-detalle">{{ paso.detalle }}</p>
                  }
                  @if (paso.comentario) {
                    <p class="tl-comentario">{{ paso.comentario }}</p>
                  }
                </div>
              </li>
            }
          </ol>
        </div>
      </div>
    }
  </ng-template>
</nz-modal>
